import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    @media (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`;

export const Title = styled.div``;

export const H4 = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 24px;
    svg{
        color: ${(props) => props.isOpen ? props.theme.colors.success : props.theme.colors.primary};
    }
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const TitleRight = styled.div`
    display: flex;
    flex-direction: column;

    align-items: flex-start;
    color: ${(props) => props.theme.colors.gray.gray_800};

    @media (max-width: 900px) {
        width: 100%;
    }
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 8px 10px;

    width: 100%;
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const InforUser = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
`;

export const Input = styled.input`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 16px;
`;